import React from 'react';
import { useIsomorphicLayoutEffect } from 'hooks/useIsomorphicLayoutEffect';
import config from 'libs/config';

export type WithDocumentTitleProps = {
  title: string;
} & React.PropsWithChildren;

function WithDocumentTitle({ title, children }: WithDocumentTitleProps) {
  useIsomorphicLayoutEffect(() => {
    const prefix = config.domain.isDefaultDomain
      ? `Kampus Advanced Marketing Platform from KORTX`
      : 'Kampus Advanced Marketing Platform';

    window.document.title = title ? `${prefix} - ${title}` : prefix;
  }, [title]);

  return <>{children}</>;
}

export default WithDocumentTitle;
